import React from 'react';

import { ActionFeedItem } from './ActionFeedItem.component';

export default ActionFeedItem;
